import Filters from "../Filters";

const FiltersWrapper = () => <Filters />;

export default FiltersWrapper;
